import { Modal, Button } from "react-bootstrap";
import { FiTrash2 } from "react-icons/fi";

export default function DeleteModal({ show, onHide, onDelete }) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body className="text-center">

        <FiTrash2 size={40} className="text-danger mb-3" />

        <h5>Confirm Delete</h5>
        <p>This action cannot be undone.</p>

        <div className="d-flex justify-content-center gap-2">
          <Button variant="light" onClick={onHide}>
            Cancel
          </Button>
          <Button  onClick={onDelete} variant="danger">Delete</Button>
        </div>

      </Modal.Body>
    </Modal>
  );
}